<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleCreate"
    >
      <el-steps simple :active="0" finish-status="success" slot="header" style="margin-bottom: 20px;">
        <el-step title="创建页面"></el-step>
        <el-step title="制作页面"></el-step>
      </el-steps>
    </c-source-form>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CustompagesNew extends Vue {

  data = {}

  get columns() {
    return [
      {
        prop: 'name',
        label: '页面名',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'en_name',
        label: '页面英文名',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'share_words',
        label: '分享语',
        form: {
          component: 'input'
        }
      },
      {
        prop: 'share_cover',
        label: '分享卡片图',
        form: {
          component: 'upload'
        }
      }
    ]
  }

  async handleCreate(data) {
    const res = await this.$autoLoading(this.$request.post('/custom_pages', data));
    this.$message.success('新建自定义页面完成');
    this.$router.push({ name: 'custom_pages.edit', params: { id: res.id }, query: { step: 1 } });
  }
}
</script>
